export function validUrl(str) {
    // Regular expression pattern to match a URL
    var urlPattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
    
    // Test the input string against the pattern
    return urlPattern.test(str);
}

/* export function validUrl(string) {
    let url;

    try {
        url = new URL(string);
    } catch (_) {
        return false;
    }

    return url.protocol === "http:" || url.protocol === "https:";
}*/

